export default "__VITE_ASSET__CJHOp5c0__"